import type { LucideProps } from "lucide-react";

import React from "react";

import { getColorClasses } from "@/features/products/utils";
import { ArrowUpRight } from "lucide-react";

interface ProductTypeCardProps {
  title: string;
  description: string;
  icon: React.ComponentType<LucideProps>;
  color: string;
  onClick: () => void;
}

export function ProductTypeCard({
  title,
  description,
  icon: Icon,
  color,
  onClick,
}: ProductTypeCardProps) {
  const { iconBg, iconBorder, iconColor } = getColorClasses(color);

  return (
    <div
      className="flex flex-col justify-center items-start p-4 gap-2 w-full bg-white border-0.5 border-border shadow-panel rounded-xl cursor-pointer hover:shadow-lg transition-shadow"
      onClick={onClick}
    >
      <div className="flex flex-row justify-between items-start w-full h-8">
        <div className="flex items-center justify-center">
          <div
            className={`w-8 h-8 rounded-lg flex items-center justify-center border ${iconBorder} ${iconBg} shadow-sm`}
          >
            <Icon size={16} className={iconColor} strokeWidth={1.33} />
          </div>
        </div>
        <ArrowUpRight size={16} className="text-default opacity-0" />
      </div>

      <div className="flex flex-col items-start gap-0.5 w-full">
        <div className="header-h4 text-default">{title}</div>
        <div className="text-sm text-muted leading-4">{description}</div>
      </div>
    </div>
  );
}
